import React from 'react';
import PropTypes from 'prop-types';
import { AccountLink } from './SideNavOrg';
import { ORG_PATHS } from '../constants';
import { injectParams } from '../utils/pathHelpers';

const GroupDropdown = ({ organizationId, pathname }) => {
  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', paddingLeft: '12px' }}
    >
      <AccountLink
        to={injectParams(ORG_PATHS.PCO_GROUP, {
          organizationId,
        })}
        style={{
          fontSize: '14px',
          color: pathname.includes('pco-groups') ? '#414042' : '#476692',
          fontWeight: pathname.includes('pco-groups') ? 'bold' : 'normal',
        }}
        data-qa-hook="pco-groups.link"
        activeLink={pathname.includes('pco-groups')}
      >
        PCO Groups
      </AccountLink>
    </div>
  );
};

export default GroupDropdown;

const { string } = PropTypes;
GroupDropdown.propTypes = {
  organizationId: string.isRequired,
  pathname: string.isRequired,
};
